import axios from 'axios';

export const toggleStoreActiveByGuid = (storeGuid) => axios.put(`/store/${storeGuid}/toggleactive`);
